import { ArrowDownRight, ArrowUpRight, type LucideIcon } from 'lucide-react'
import { Card } from '@/design-system/components/Card/Card'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'
import type { StatusTone } from '@/design-system/components/StatusBadge/StatusBadge'

export interface StatCardProps {
  label: string
  value: string
  detail: string
  icon: LucideIcon
  tone: StatusTone
  trend?: 'up' | 'down'
}

export function StatCard({ label, value, detail, icon: Icon, tone, trend }: StatCardProps) {
  const TrendIcon = trend === 'down' ? ArrowDownRight : ArrowUpRight

  return (
    <Card className="ds-stat-card" padding="compact">
      <span className={mergeClassNames('ds-stat-card__icon', `ds-tone--${tone}`)}>
        <Icon aria-hidden="true" />
      </span>
      <span className="ds-stat-card__content">
        <span className="ds-stat-card__label">{label}</span>
        <strong className="ds-stat-card__value numeric">{value}</strong>
        <span className={mergeClassNames('ds-stat-card__detail', `ds-text--${tone}`)}>
          {trend ? <TrendIcon aria-hidden="true" /> : null}
          {detail}
        </span>
      </span>
    </Card>
  )
}
